<script>
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import { Line, mixins } from 'vue-chartjs'

export default {
  components: {
    ChartJSPluginDatalabels,
  },
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object,
    options: Object,
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
